import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { LayoutDashboard, Coins, Star, Mail, Image, FileText, HelpCircle, Search, LogOut } from "lucide-react";

const menu = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/quotazioni", label: "Quotazioni", icon: Coins },
  { to: "/admin/recensioni", label: "Recensioni", icon: Star },
  { to: "/admin/contatti", label: "Richieste", icon: Mail },
  { to: "/admin/banner", label: "Banner Home", icon: Image },
  { to: "/admin/contenuti", label: "Contenuti", icon: FileText },
  { to: "/admin/faq", label: "FAQ", icon: HelpCircle },
  { to: "/admin/seo", label: "SEO", icon: Search },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div data-testid="admin-layout" className="min-h-screen flex bg-[#060f1f]">
      <aside className="w-64 bg-[#0a1628] border-r border-white/5 flex flex-col">
        <div className="px-6 py-7 border-b border-white/5">
          <div className="font-serif text-xl text-white">Affari Oro</div>
          <div className="text-[0.6rem] uppercase tracking-[0.3em] text-[var(--gold-soft)]">Admin Panel</div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {menu.map((m) => (
            <NavLink
              key={m.to}
              to={m.to}
              end={m.end}
              data-testid={`admin-menu-${m.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 text-sm transition-colors rounded-sm ${
                  isActive
                    ? "bg-[var(--gold)]/10 text-[var(--gold)] border-l-2 border-[var(--gold)]"
                    : "text-white/60 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <m.icon size={16} />
              {m.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/5">
          <div className="text-xs text-white/40 mb-1">Connesso come</div>
          <div className="text-sm text-white mb-3 truncate">{user?.email}</div>
          <button data-testid="admin-logout" onClick={handleLogout} className="flex items-center gap-2 text-xs text-white/50 hover:text-[var(--gold)]">
            <LogOut size={14} /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
